<template>
  <div class="user-slider">
    <ol class="slider-container" :class="sliderPostion">
      <li :class="sliderActive == 0? 'slider-active':''" class="slider-01">
        <div class="slider-div css-01 no-height js-anime" data-anime="no-height" data-delay = "800" data-type="remove" @click="changeItem(0)">
          <div class="item">
            <img v-if="showIcon == 'number'" :src="static_img_url + 'pic/index/01-big.png'" class="big-img">
            <a v-if="showIcon == 'botton' && sliderActive == 0" :href="data[0].url" class="href" target="_blank">报名参选</a>
            <div class="text-content">
              <p class="tle">{{data[0] ? data[0].title : '未来医疗100强'}}</p>
              <p v-html="data[0] ? data[0].summary : ''"></p>
            </div>
            <div v-if="sliderActive == 0 && start" class="schedule" :class="sliderActive == 0 && start?'animeAddWidth':''"></div>
          </div>
          <div class="item-sm">
            <img v-if="showIcon == 'number'" :src="static_img_url + 'pic/index/01-small.png'">
            <span v-if="showIcon == 'botton'" style="color:#d6a24d">{{data[0].title}}</span>
          </div>
        </div>
      </li>
      <li :class="sliderActive == 1? 'slider-active':''" class="slider-02">
        <div class="slider-div css-02 no-width js-anime" data-anime="no-width" data-delay = "400" data-type="remove"  @click="changeItem(1)">
          <div class="item">
            <img v-if="showIcon == 'number'" :src="static_img_url + 'pic/index/02-big.png'" class="big-img">
            <a v-if="showIcon == 'botton' && sliderActive == 1" :href="data[1].url" class="href href-02" target="_blank">报名参选</a>
            <div class="text-content">
              <p class="tle">{{data[1] ? data[1].title : '未来医疗100强'}}</p>
              <p v-html="data[1] ? data[1].summary : ''"></p>
            </div>
            <div v-if="sliderActive == 1 && start" class="schedule" :class="sliderActive == 1 && start?'animeAddWidth':''"></div>
          </div>
          <div class="item-sm">
            <img v-if="showIcon == 'number'" :src="static_img_url + 'pic/index/02-small.png'">
            <span v-if="showIcon == 'botton'" style="color:#ffffff">{{data[1].title}}</span>
          </div>
        </div>
      </li>
      <li :class="sliderActive == 2? 'slider-active':''"  class="slider-03">
        <div class="slider-div css-03 no-height js-anime" data-anime="no-height" data-delay = "1" data-type="remove"  @click="changeItem(2)">
          <div class="item">
            <img v-if="showIcon == 'number'" :src="static_img_url + 'pic/index/03-big.png'" class="big-img">
            <a v-if="showIcon == 'botton' && sliderActive == 2" :href="data[2].url" class="href" target="_blank">报名参选</a>
            <div class="text-content">
              <p class="tle">{{data[2] ? data[2].title : '未来医疗100强'}}</p>
              <p v-html="data[2] ? data[2].summary : ''"></p>
            </div>
            <div v-if="sliderActive == 2 && start" class="schedule" :class="sliderActive == 2 && start?'animeAddWidth':''"></div>
          </div>
          <div class="item-sm">
            <img v-if="showIcon == 'number'" :src="static_img_url + 'pic/index/03-small.png'">
            <span v-if="showIcon == 'botton'" style="color:#000000">{{data[2].title}}</span>
          </div>
        </div>
      </li>
    </ol>
  </div>
  
</template>

<script>
import { anima_mixins } from 'js/anima_mixins.js'
export default {
  mixins:[anima_mixins],
  props:{
    showIcon: {
      // number: 代表数字图标   botton: 跳转按钮
      type: String,
      default: 'number'
    },
    data: Array,
    exit: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      static_img_url: process.env.VUE_APP_CDN,

      start: false,
      times: '',
      seepd: 5000,
      sliderActive: 0,
      isLockChange: false // false 不锁定 
    }
  },
  mounted(){
    this.initAnime()
    // setTimeout(() =>{
    //   this.initInterval()
    // },800)
  },
  computed:{
    sliderPostion() {
      return {
        'slider-p-01': this.sliderActive == 0,
        'slider-p-02': this.sliderActive == 1,
        'slider-p-03': this.sliderActive == 2,
        'exit-slider': this.exit
      }
    }
  },
  watch: {
    exit(n, o){
      if( n == true ){
        clearInterval(this.times)
      }else{
        this.initInterval()
      }
    }
  },
  methods:{
    initInterval(){
      this.start = true
      this.times = setInterval(() => {
        let num = this.sliderActive + 1
          if(num == 3){
            num = 0
          }
          this.sliderActive = num
          this.$emit('getAvtiveIndex',{activeIndex: num})
        },this.seepd)
    },
    changeItem(idx){
      // console.log(idx)
      if( this.isLockChange ){
        return
      }
      this.isLockChange = true
      this.start = false
      clearInterval(this.times)
      this.sliderActive = idx
      this.$emit('getAvtiveIndex',{activeIndex: idx})
      setTimeout(() => {
        this.isLockChange = false
        this.initInterval()
      },600)
    }
  }
};
</script>

<style lang="stylus" scoped>
px2vh(px) // 高
    (px/1080)*100vh

.slider-container
  width: 280px
  height: 280px
  display inline-flex
  flex-direction column
  flex-wrap wrap
  transition all .6s
  // 选中时最外层容器位置和部分切片变化
  &.slider-p-01
    transform translate(0,0)
  &.slider-p-02
    transform translate(0,-280px)
    .slider-03
      transform translate(0,140px)
  &.slider-p-03
    transform translate(-280px,-280px)
    .slider-01
      transform translate(140px,0)
    .slider-03
      transform translate(0,140px)
  li
    position relative
    width 140px
    height 140px
    transition all .6s
    .slider-div
      cursor pointer
      position absolute
      transition all .6s
      width 100%
      height 100%
      overflow hidden
      &.css-01
        .tle
            color #D6A24D
        .text-content
            color #FFFFFF
      &.css-02
        .tle
            color #000000
        .text-content
            color #333333
      &.css-03
        .tle
            color #D6A24D
        .text-content
            color #000000
      
      .item-sm, .item 
        position absolute
      .item-sm
        opacity 1
        width 140px
        height 140px
        left 50%
        top 50%
        transform translate(-50%,-50%)
        display flex
        align-items center
        justify-content center
        img 
          height 14px
        span 
          font-size 16px
          font-weight:400;
      .item
        position relative
        width 140px
        height 140px
        padding 0
        .schedule
          position absolute
          width 100%
          bottom 0
          height 3px
          background:linear-gradient(90deg,rgba(214,162,77,1),rgba(255,215,149,1));
          left 0
        .big-img
          position absolute
          height 14px
          left 5px
          bottom 15px
          opacity 0
        .href
          cursor pointer
          position absolute
          z-index 1
          left 5px
          bottom 15px
          opacity 0
          transform scale(.3)
          display inline-block
          width:120px;
          height:40px;
          background:linear-gradient(-45deg,rgba(214,162,77,1),rgba(255,215,149,1));
          border-radius:20px;
          color #000000
          font-size:14px;
          text-align center
          line-height 40px
          &:hover
            color #ffffff
        .href-02
          background #000000
          color #ffffff
          &:hover
            color #d6a24d
        .text-content
          position absolute
          right -160px
          top 160px
          width 140px
          height 140px
          font-size 13px
          line-height:24px;
          white-space nowrap
          opacity 0
          .tle
            font-size 14px
            margin-bottom  20px
    &.slider-01 .slider-div
      background #000000
      bottom 0
    &.slider-02 .slider-div
      right 0
      bottom 0
      background:linear-gradient(-45deg,rgba(214,162,77,1),rgba(255,215,149,1));
    &.slider-03 .slider-div
      top 0
      background #FFFFFF
    // 选中切片时
    &.slider-active
      position relative
      .slider-div
        width 400px
        height 400px
      .css-01
        transform translate(-260px, 0);
      .css-02
        transform translate(0,260px)
      // .css-03
      //   transform translate(0, 140px)
      .item
        width 400px
        height 400px
        padding 60px
        .big-img
          height 45px
          left 20px
          bottom 60px
          opacity 1
        .href
          left 60px
          bottom 60px
          opacity 1
          transform scale(1)
        .text-content
          position absolute
          right 60px
          top 60px
          width: calc(100% - 120px)
          height calc(100% - 120px)
          font-size 13px
          line-height:24px;
          opacity 1
      .item-sm
        opacity 0
.exit-slider
  li
    >div
      height 0 !important
.no-width
  width 0 !important
.no-height
  height 0 !important
//宽度从0到100%
.animeAddWidth
  animation: animeAddWidth 5s linear;
@keyframes animeAddWidth
  0%
    width: 0
  100%
    width: 100%
</style>